var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnhealthy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unhealthy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unhealthy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#EC5632",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4953156,6 C12.785965,6 13,6.22401312 13,6.50034732 L13,6.50034732 L13,11 L17.4996527,11 C17.7408498,11 17.9485882,11.1785323 17.9917745,11.4139668 L18,11.5046844 L18,12.4953156 C18,12.785965 17.7759869,13 17.4996527,13 L17.4996527,13 L13,13 L13,17.4996527 C13,17.7408498 12.8214677,17.9485882 12.5860332,17.9917745 L12.4953156,18 L11.5046844,18 C11.214035,18 11,17.7759869 11,17.4996527 L11,17.4996527 L11,13 L6.50034732,13 C6.25915021,13 6.05141181,12.8214677 6.00822546,12.5860332 L6,12.4953156 L6,11.5046844 C6,11.214035 6.22401312,11 6.50034732,11 L6.50034732,11 L11,11 L11,6.50034732 C11,6.25915021 11.1785323,6.05141181 11.4139668,6.00822546 L11.5046844,6 Z",
    id: "Increase",
    fill: "#FFFFFF",
    transform: "translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhealthy);
export default __webpack_public_path__ + "static/media/unhealthy.51ca8f3de00b92e56b9d349eda7b33a6.svg";
export { ForwardRef as ReactComponent };